import { Component } from 'react'
import PopupModal from './PopupModal'
import Modal from '.'
import ShiftPasswordForm from '../forms/popups/ShiftPasswordForm'

interface AddShiftModalProps {
  fetchList: (list: string) => void
  createItem: (data: any) => void
  showToast: (options: { title: string }) => void
  fields: any // Replace 'any' with a specific type if available
  isOpen: boolean
}

export class AddShiftModal extends Component<AddShiftModalProps> {
  handleSubmit = () => {
    const { fetchList, createItem, showToast } = this.props
    createItem({
      url: 'list/shifts',
      onComplete: () => {
        showToast({ title: 'Added a Shift' })
        fetchList('shifts')
      }
    })
  }

  render() {
    const { fields, isOpen, ...formProps } = this.props

    if (!isOpen) return null
    return (
      <PopupModal
        confirmText="Add"
        buttonIcon="PlusOutlined"
        buttonColour="success"
        list="Shift"
        includesRequired
        onConfirm={this.handleSubmit}
        supportArticle={SUPPORT_ARTICLE}
        type="create"
        footerStyle={styles.footer}
        {...formProps}
      >
        <ShiftPasswordForm fields={fields} formId={MODAL_ID} />
      </PopupModal>
    )
  }
}

const MODAL_ID = 'addShift'
const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/the-care-office/finishing-your-essential-setup/how-do-i-set-up-a-shift-password'

const styles = {
  footer: {
    justifyContent: 'space-between'
  }
}

export default Modal(AddShiftModal, MODAL_ID)
